<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['begGift'],
      }"
      @click="configMainShow['begGift'] = !configMainShow['begGift']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>智能狗</span>
        <span class="el-switch" @click.stop="toggleEnable('begGift', '智能狗')">
          <el-switch v-model="configure.begGift.enable" disabled></el-switch>
        </span>
      </div>
    </div>

    <div
      class="bd"
      @click="
        isNaN(featureList['begGift'].timeRemaining)
          ? shoWDialogBuy(
              featureList['begGift']['productKey'],
              '智能狗',
              'begGift'
            )
          : featureList['begGift'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.begGift.enable
          ? ''
          : toggleEnable('begGift', '智能狗')
      "
      :class="{
        'no-buy': isNaN(featureList['begGift'].timeRemaining),
        expired: featureList['begGift'].timeRemaining <= 0,
        'shut-off': !configure.begGift.enable,
      }"
    >
      <el-row>
        <el-col :span="5">频率控制</el-col>
        <el-col :span="19">
          <div>
            每
            <el-input-number
              v-model="configure.begGift.time"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :precision="1"
              size="mini"
            ></el-input-number
            >分钟，狗一次。
          </div>
          <div>
            同一用户，一天最多狗
            <el-input-number
              v-model="configure.begGift.dayMaxCount"
              :controls-position="isPC ? 'right' : ''"
              size="mini"
            ></el-input-number
            >次，一周最多狗
            <el-input-number
              v-model="configure.begGift.maxDays"
              :controls-position="isPC ? 'right' : ''"
              size="mini"
            ></el-input-number
            >天
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">触发事件</el-col>
        <el-col :span="19">
          <div class="block-tag">
            礼物标签：会自动计算并选择礼物。
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.begGift.weekRankUpgradeEnable"
            ></el-switch
            >周贡榜排名即将提升，狗一下
            <div
              class="sentence"
              v-if="configure.begGift.weekRankUpgradeEnable"
            >
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.weekRankUpgradeTpl[0]"
                    @input="checkEmpty(configure.begGift.weekRankUpgradeTpl, 0)"
                    :labels="['userNick', 'gift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.begGift.surpassHundredEnable"
            ></el-switch
            >即将突破百元榜，狗一下， 距
            <el-input-number
              v-model="configure.begGift.surpassHundredGapMoney"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :precision="0"
              size="mini"
            ></el-input-number
            >元，开狗
            <div class="sentence" v-if="configure.begGift.surpassHundredEnable">
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.surpassHundredTpl[0]"
                    @input="checkEmpty(configure.begGift.surpassHundredTpl, 0)"
                    :labels="['userNick', 'gift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.begGift.surpassThousandEnable"
            ></el-switch
            >即将突破千元榜，狗一下， 距
            <el-input-number
              v-model="configure.begGift.surpassThousandGapMoney"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :precision="0"
              size="mini"
            ></el-input-number
            >元，开狗
            <div
              class="sentence"
              v-if="configure.begGift.surpassThousandEnable"
            >
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.surpassThousandTpl[0]"
                    @input="checkEmpty(configure.begGift.surpassThousandTpl, 0)"
                    :labels="['userNick', 'gift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.begGift.surpassWanEnable"></el-switch
            >即将突破万元榜，狗一下， 距
            <el-input-number
              v-model="configure.begGift.surpassWanGapMoney"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :precision="0"
              size="mini"
            ></el-input-number
            >元，开狗
            <div class="sentence" v-if="configure.begGift.surpassWanEnable">
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.surpassWanTpl[0]"
                    @input="checkEmpty(configure.begGift.surpassWanTpl, 0)"
                    :labels="['userNick', 'gift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.begGift.managerEnable"></el-switch
            >即将卡房管，狗一下。卡房管条件
            <el-input-number
              v-model="configure.begGift.managerGapMoney"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
            ></el-input-number
            >元
            <div class="sentence" v-if="configure.begGift.managerEnable">
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.managerTpl[0]"
                    @input="checkEmpty(configure.begGift.managerTpl, 0)"
                    :labels="['userNick', 'gift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.begGift.yepaiEnable"></el-switch
            >即将卡爷，狗一下。卡爷条件
            <el-input-number
              v-model="configure.begGift.yepaiGapMoney"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
            ></el-input-number
            >元
            <div class="sentence" v-if="configure.begGift.yepaiEnable">
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.yepaiTp[0]"
                    @input="checkEmpty(configure.begGift.yepaiTp, 0)"
                    :labels="['userNick', 'gift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.begGift.fansBadgeEnable"></el-switch
            >没有粉丝牌子，狗一下。
            <div class="sentence" v-if="configure.begGift.fansBadgeEnable">
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.fansBadgeTpl[0]"
                    @input="checkEmpty(configure.begGift.fansBadgeTpl, 0)"
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.begGift.fansLevelUpgradeEnable"
            ></el-switch
            >粉丝牌子即将提升，狗一下。
            <div
              class="sentence"
              v-if="configure.begGift.fansLevelUpgradeEnable"
            >
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.fansLevelUpgradeTpl[0]"
                    @input="
                      checkEmpty(configure.begGift.fansLevelUpgradeTpl, 0)
                    "
                    :labels="['userNick', 'gift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.begGift.nobleContinueEnable"
            ></el-switch
            >大哥续费贵族，钱包余额，狗一下。
            <div class="sentence" v-if="configure.begGift.nobleContinueEnable">
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.nobleContinueTpl[0]"
                    @input="checkEmpty(configure.begGift.nobleContinueTpl, 0)"
                    :labels="['userNick', 'walletGift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.begGift.vipBarPeepEnable"></el-switch
            >贵宾席偷看
            <el-input-number
              v-model="configure.begGift.vipBarPeepTime"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
            ></el-input-number
            >分钟以上的，狗一下。
            <div class="sentence" v-if="configure.begGift.vipBarPeepEnable">
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.vipBarPeepTpl[0]"
                    @input="checkEmpty(configure.begGift.vipBarPeepTpl, 0)"
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.begGift.nickPrefix.enable"></el-switch
            >粉丝牌子≥
            <el-input-number
              v-model="configure.begGift.nickPrefix.fansBadgeLevel"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
            ></el-input-number
            >级，狗马甲
            <el-input
              style="width:120px"
              size="mini"
              v-model.trim="configure.begGift.nickPrefix.prefixName"
              placeholder="请输入马甲格式"
            ></el-input>
            <div class="sentence" v-if="configure.begGift.nickPrefix.enable">
              <ul>
                <li>
                  <Editor
                    v-model="configure.begGift.nickPrefix.nickPrefixTpl[0]"
                    @input="
                      checkEmpty(configure.begGift.nickPrefix.nickPrefixTpl, 0)
                    "
                    :labels="['userNick', 'nickPrefix', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
            <q>
              用户昵称中没有所填字符，就会开狗。不要写成“xx【小虎粉】”直接写“【小虎粉】”即可
            </q>
          </div>
        </el-col>
      </el-row>
      <!-- <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">
          其他设置
          <span id="begGiftBigData" class="hide-anchor-point"></span>
        </el-col>
        <el-col :span="19">
          <div class="block-tag warning"
            v-if="
              isNaN(featureList['bigData'].timeRemaining) ||
                featureList['bigData'].timeRemaining <= 0
            ">
            近期消费能力需要「大数据」功能支持。
            <el-link
              class="block-tag-link"
              type="primary"
              :underline="false"
              @click="
                shoWDialogBuy(
                  featureList['bigData']['productKey'],
                  '大数据',
                  'bigData'
                )
              "
              >立即开通</el-link
            >
          </div>
          <div
            class="row-padding big-data-modules"
            @click="
              isNaN(featureList['bigData'].timeRemaining)
                ? shoWDialogBuy(
                    featureList['bigData']['productKey'],
                    '大数据',
                    'bigData'
                  )
                : featureList['bigData'].timeRemaining <= 0
                ? showFunctionalRenewal(true)
                : configure.bigData.enable
                ? ''
                : toggleEnable('bigData', '大数据')
            "
            :class="{
              'no-buy': isNaN(featureList['bigData'].timeRemaining),
              expired: featureList['bigData'].timeRemaining <= 0,
              'shut-off': !configure.bigData.enable,
            }"
          >
            <el-switch v-model="configure.begGift.forConsumeEnable"></el-switch
            >根据近期消费能力，优选目标。
          </div>
        </el-col>
      </el-row> -->
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('智能狗', 'begGift')"
          >「智能狗」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {};
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  mounted() {},
  methods: {},
};
</script>
